import { useState, useEffect, useRef } from "react";
import { getI18n, useTranslations, t } from "~/translations/utils";
import logiveryIcon from "~/assets/icons/logivery-icon.png";
import enFlag from "~/assets/icons/en.gif";
import itFlag from "~/assets/icons/it.gif";

export function Navbar({ appMode }) {
  useTranslations();

  const [showNavbarMenu, setShowNavbarMenu] = useState(false);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdownMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <nav
      className="navbar has-shadow"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <div className="navbar-brand">
          <img
            src={logiveryIcon}
            className="navbar-item"
            alt="Logivery logo"
            style={{ maxHeight: "4rem" }}
          />
          <div
            className={`navbar-burger ${showNavbarMenu ? "is-active" : ""}`}
            role="button"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarMenu"
            onClick={() => setShowNavbarMenu(!showNavbarMenu)}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </div>
        </div>
        <div className={`navbar-menu  ${showNavbarMenu ? "is-active" : ""}`}>
          <div className="navbar-start">
            <a className="navbar-item" href="/">
              {t("navigation.home")}
            </a>
            {appMode && (
              <div
                tabIndex="0"
                className={`navbar-item has-dropdown ${showDropdownMenu ? "is-active" : ""}`}
                onClick={() => setShowDropdownMenu(!showDropdownMenu)}
                ref={dropdownRef}
              >
                <span className="navbar-link">App</span>
                <div className="navbar-dropdown is-boxed">
                  <a className="navbar-item" href="/app">
                    {t("navigation.index")}
                  </a>
                  <a className="navbar-item" href="/app/settings">
                    {t("navigation.settings")}
                  </a>
                  <a className="navbar-item" href="/app/logs">
                    {t("navigation.logs")}
                  </a>
                </div>
              </div>
            )}
          </div>
          <div id="navbarMenu" className={`navbar-end has-text-right`}>
            <a
              href="?lang=it"
              className={`is-flex is-justify-content-center navbar-item ${getI18n().locale == "it" ? "is-selected" : ""}`}
              style={{ width: "100%" }}
            >
              <img className="image is-3by2" src={itFlag} alt="Italiano" />
            </a>
            <a
              href="?lang=en"
              className={`is-flex is-justify-content-center navbar-item ${getI18n().locale == "en" ? "is-selected" : ""}`}
              style={{ width: "100%" }}
            >
              <img className="image is-3by2" src={enFlag} alt="English" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
